module.exports = __webpack_public_path__ + "img/dedicated-claims-concierge@2x.17ff529b.jpg";